import styled from "styled-components";
import { grayColor } from "~/components/layout/Variables";

export const ContainerType = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  @media(max-width: 770px) {
    flex-direction: column;
  }
`;

export const CardType = styled.div`
  margin: 0.5rem 0rem;
  width: 100%;
`;


export const CardTypeLeft = styled.div`
  margin: 1rem 0rem;
  width: 100%;
  margin-right: 0.5rem;

  @media(max-width: 770px) {
    margin-right: 0rem;
  }
`;


export const CardTypeRight = styled.div`
  margin: 1rem 0rem;
  width: 100%;
  margin-left: 0.5rem;

  @media(max-width: 770px) {
    margin: 0.5rem 0rem;
  }
`;

export const ItemCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem;

  &:not(:first-child) {
    border-top: 0.6px solid rgba(150, 150, 150, 0.5);
  }

  img {
    width: 14%;
    margin-right: 0.5rem;

    @media(max-width: 770px) {
      width: 7%;
    }

    @media(max-width: 550px) {
      width: 10%;
    }
  }
`;

export const ItemDropDown = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:first-child) {
    border-top: 0.6px solid rgba(150, 150, 150, 0.5);
  }
`;

export const TextCard = styled.p`
  margin: 0;
  color: ${() => grayColor};
  padding: ${(props) => props.padding};
`;

export const AlignDropdownBranch = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
};

export const Select = styled.button`
  width: ${(props) => (props.width ? props.width : `100%`)};
  font-size: 0.95rem;
  border: 0.6px solid rgba(80, 80, 80, 0.3);
  background-color: #fff;
  box-shadow: 0px 2px 2px #00000029;
  border-radius: 0.4rem;
  padding: 0.2rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${(props) => props.margin};

  span {
    color: #808080;
  }
`;

export const AlignItens= styled.div`
  display: grid;
  grid-template-columns: 15% 65% 20%;
  width: 100%;

  .product {
    margin: .5rem 0 .5rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .align-icon {
    margin: .5rem;
  }
`;
